var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',{attrs:{"svg-path":_vm.$options.ERROR_STATE_SVG,"title":_vm.s__('Pipelines|There was an error fetching the pipelines.'),"description":_vm.s__('Pipelines|Try again in a few moments or contact your support team.')}})
}
var staticRenderFns = []

export { render, staticRenderFns }